<mat-card appearance="outlined" class="selection-card"
          [ngClass]="{'card-expandable': expandable, 'expanded': cardExpanded, 'card-with-header': !expandable}">
  <div class="card-header" (click)="expandable && toggleExpanded()">
    <h3 class="no-margin bold break-word">{{ title | translate }}</h3>
    <div class="flex flex-end">
      <mat-icon class="svg-icon expand-icon" [svgIcon]="'arrow_down'" *ngIf="expandable"></mat-icon>
    </div>
  </div>
  <div #selectionContent class="card-content" *ngIf="!expandable || cardExpanded">
    <ng-container *ngIf="withSearch">
      <div class="search-input-wrapper">
        <mat-checkbox (change)="toggleAll($event)" [checked]="areAllSelected()" [indeterminate]="areSomeSelected()"></mat-checkbox>
        <input #searchInput type="text" class="search-input" autocomplete="off"
               [placeholder]="placeholder | translate" [formControl]="searchControl"
               (keydown)="handleKeyDown($event)"/>
        <button mat-icon-button class="search-input-clear" *ngIf="searchControl.value" (click)="clearSearch(true)">
          <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
        </button>
      </div>
      <div class="card-grid selection-grid">
        <div class="flex flex-row" *ngFor="let filteredItem of itemListFiltered | async">
          <ng-container [ngTemplateOutlet]="itemRowTemplate" [ngTemplateOutletContext]="{rowItem: filteredItem}"></ng-container>
        </div>
        <div class="text-muted" *ngIf="noListValues">
          <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
          {{ 'general.api_select_no_values' | translate }}
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!withSearch">
      <div class="select-all-wrapper">
        <mat-checkbox (change)="toggleAll($event)" [checked]="areAllSelected()" [indeterminate]="areSomeSelected()">
          {{ 'general.api_select_all' | translate }}
        </mat-checkbox>
      </div>
      <div class="card-grid selection-grid">
        <div class="flex flex-row" *ngFor="let item of itemList">
          <ng-container [ngTemplateOutlet]="itemRowTemplate" [ngTemplateOutletContext]="{rowItem: item}"></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</mat-card>
<ng-template #itemRowTemplate let-rowItem="rowItem">
  <mat-checkbox (change)="toggleItem($event, rowItem)" [checked]="isItemSelected(rowItem)">
    <ng-container *ngIf="!itemTemplate" [ngTemplateOutlet]="defaultItemTemplate" [ngTemplateOutletContext]="{item: rowItem}"></ng-container>
    <ng-container *ngIf="itemTemplate" [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{item: rowItem}"></ng-container>
  </mat-checkbox>
</ng-template>
<ng-template #defaultItemTemplate let-item="item">
  <span>{{ item }}</span>
</ng-template>
